import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/data/catalog";

const AuthCtx = createContext({ user: null, token: null, login: () => {}, logout: () => {} });
const KEY = "if_account_token";

export const formatApiError = (detail, fallback = "Operazione non riuscita. Riprova.") => {
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.message || detail.msg || fallback;
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(KEY));
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);

  const refreshAccount = useCallback(async () => {
    if (!token) return;
    try { const res = await axios.get(`${API}/account/me`, { headers: { Authorization: `Bearer ${token}` } }); setUser(res.data.user); setOrders(res.data.orders); }
    catch { localStorage.removeItem(KEY); setToken(null); setUser(false); }
  }, [token]);

  useEffect(() => {
    if (!token) { setUser(false); return; }
    refreshAccount();
  }, [token, refreshAccount]);

  const login = (tk, u) => { localStorage.setItem(KEY, tk); setUser(u); setToken(tk); };
  const logout = () => { localStorage.removeItem(KEY); setToken(null); setUser(false); setOrders([]); };
  return <AuthCtx.Provider value={{ user, token, orders, login, logout, refreshAccount }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
